import { render, staticRenderFns } from "./noticeArea.vue?vue&type=template&id=638b54bc&scoped=true"
import script from "./noticeArea.vue?vue&type=script&lang=js"
export * from "./noticeArea.vue?vue&type=script&lang=js"
import style0 from "./noticeArea.vue?vue&type=style&index=0&id=638b54bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b54bc",
  null
  
)

export default component.exports